import React, { useEffect, useState } from "react";
import axios from "axios";
import userAuthenticationConfig from "../../../../../utils/userAuthenticationConfig";
import { checkFilterItem, fetchFilterData } from "../../../../../utils/fetchFilterData";
import { useHistory } from "react-router-dom";
import MaterialPagination from "../../../../styles/materialPagination";
import ProjectConnectionsList from "./ProjectConnectionsList";
import ProjectConnectionsFilter from "./ProjectFilter";
import FilterAppliedList from "../../../../elements/filter/FilterAppliedList";
import Notification from "../../../../elements/notification/Notification";

import { StyledProjectConnections } from "../styledProjectDetails";

const ProjectConnectionsContainer = ({ t, projectId }) => {

  const [connections, setConnections] = useState();
  const [totalPageCount, setTotalPageCount] = useState(null);

  const history = useHistory();

  const [filterData, setFilterData] = useState({
    "page": checkFilterItem(history, "page", 1, true),
    "currentTab": checkFilterItem(history, "currentTab", "connection-list", false, true),
    "service.name": checkFilterItem(history, "service.name", null),
    "id": checkFilterItem(history, "id", null),
    "createDate[gte]": checkFilterItem(history, "createDate[gte]", null, true),
    "createDate[lte]": checkFilterItem(history, "createDate[lte]", null, true),
    "enablePayment": checkFilterItem(history, "enablePayment", null),
    "enablePayout": checkFilterItem(history, "enablePayout", null)
  });

  const [notification, setNotification] = useState({
    visible: false,
    type: "",
    message: ""
  });

  const fetchConnections = () => {
    let filterUrl = fetchFilterData(filterData);
    history.replace(filterUrl);

    axios.get("/api/connections" + filterUrl + "&project.id=" + projectId, userAuthenticationConfig()).then(response => {
      if (response.status === 200) {
        setConnections(response.data["hydra:member"]);
        setTotalPageCount(response.data["hydra:totalPageCount"]);
      }
    }).catch(error => {
      setNotification({ ...notification, visible: true, type: "error", message: error.response.data.message });
    });
  };

  useEffect(() => {
    fetchConnections();
  }, [filterData]);

  const onChangePage = (event, page) => {
    setFilterData({ ...filterData, page: page });
  };

  return (
    <>
      <Notification
        notification={notification}
        setNotification={setNotification}
      />
      <StyledProjectConnections>
        <div className="projects-connection-head">
          <ProjectConnectionsFilter
            t={t}
            filterData={filterData}
            setFilterData={setFilterData}
          />
        </div>
        <FilterAppliedList
          filterData={filterData}
          setFilterData={setFilterData}
        />
        <ProjectConnectionsList t={t} connections={connections} />
        {totalPageCount > 0 &&
          <MaterialPagination
            count={totalPageCount}
            shape="rounded"
            page={filterData.page}
            onChange={(event, page) => onChangePage(event, page)}
          />}
      </StyledProjectConnections>
    </>
  );
};

export default ProjectConnectionsContainer;